import {ApplicationStoreType} from 'reducers';
import {createSelector} from 'reselect';

import {getParentProduct, getActiveChildrenProduct} from 'selectors/product/product';
import {SimpleProductFrameMSType, WindowProductMSType} from 'constants/flow/flowTypesProduct';

/**
 * Get is user want to put product into a cart for HTOF
 * @param {ApplicationStoreType} store - Application store type
 * @returns {boolean} is HTO enabled on PDP
 */
export const getIsHtoEnabledForPdp = (store: ApplicationStoreType): boolean =>
    store.productHto.enabled;

/**
 * Get status "is HTO (Home Try-on) product"
 * @param {ApplicationStoreType} store - Application store
 * @returns {boolean} Status "is HTO product"
 */
export const isHomeTryOnProduct = createSelector(
    getParentProduct,
    getActiveChildrenProduct,
    (
        parentProduct: WindowProductMSType & {status: string},
        activeChildren: SimpleProductFrameMSType,
    ): boolean => parentProduct.status === 'fulfilled' && Boolean(activeChildren.eligibleForHto),
);
